module.exports = __webpack_public_path__ + "/img/Crystal-Custom-Footprint-B9wKbF.svg";